import React, { useState, useEffect } from "react";
import { usePost } from "../../hooks/usePost";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import images from "../../common/images";

const FavouriteIcon = ({
  isLiked = true,
  style,
  iconStyle,
  title,
  buttonClassName = "",
  item,
  endpoint,
  defaultColor = "#FFFFFF",
  likedColor = "#FF0000",
}) => {
  const [heart, setHeart] = useState(isLiked);
  const navigate = useNavigate();
  const token = localStorage.getItem("userToken");
  const isLoggedIn = JSON.parse(token);

  useEffect(() => {
    setHeart(!item?.meta?.isLiked);
  }, [item?.meta?.isLiked, isLiked]);

  const onSuccess = () => {
    console.log("onSuccess called");
    setHeart((prevHeart) => !prevHeart);
  };

  const onError = () => {
    console.log("onError called");
    setHeart((prevHeart) => !prevHeart);
  };

  const { mutate } = usePost({
    url: heart ? endpoint : endpoint.replace("likes", "dislikes"),
    onSuccess: () => {
      onSuccess();
      toast.success(heart ? "Added to favourites" : "Removed from favourites");
    },
    onError,
  });

  const handleButtonPress = () => {
    if (!isLoggedIn) {
      navigate("/signin");
      return;
    }

    mutate({});
  };

  return (
    <>
      <button
        type="button"
        className={`favorites-icon ${buttonClassName}`.trim()}
        style={style}
        onClick={handleButtonPress}
        aria-label={title || (heart ? "Add to favourites" : "Remove from favourites")}
      >
        {heart ? (
          <img
            className="heart-image"
            src={images.emptyHeart}
            style={iconStyle}
          />
        ) : (
          <img
            className="heart-image"
            src={images.filledHeart}
            style={iconStyle}
          />
        )}
      </button>
    </>
  );
};

export default FavouriteIcon;
